import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "../styles/AboutUs.css";
import img2 from "../assets/2.png";
import img3 from "../assets/3.png";
import img4 from "../assets/4.png";

const slides = [
  {
    id: 1,
    image: img2,
    title: "Building Beyond Expectations",
    subtitle:
      "Excellence in commercial construction with integrity and precision.",
  },
  {
    id: 2,
    image: img3,
    title: "Innovative Construction Solutions",
    subtitle: "Where technology meets craftsmanship.",
  },
  {
    id: 3,
    image: img4,
    title: "Your Vision, Our Blueprint",
    subtitle: "Delivering exceptional results every time.",
  },
];

const variants = {
  enter: (direction) => ({
    x: direction > 0 ? 300 : -300,
    opacity: 0,
  }),
  center: {
    x: 0,
    opacity: 1,
  },
  exit: (direction) => ({
    x: direction < 0 ? 300 : -300,
    opacity: 0,
  }),
};

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.3, duration: 0.6 },
  }),
};

const About = () => {
  const navigate = useNavigate();
  const [[page, direction], setPage] = useState([0, 0]);

  const paginate = (newDirection) => {
    setPage(([prev]) => [
      (prev + newDirection + slides.length) % slides.length,
      newDirection,
    ]);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      paginate(1);
    }, 5000);
    return () => clearInterval(interval);
  }, [page]);

  const currentSlide = slides[page];
  return (
    <>
      <motion.div
        className="page"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="carousel-container">
          <AnimatePresence custom={direction}>
            <motion.div
              key={currentSlide.id}
              custom={direction}
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ duration: 0.6, ease: "easeInOut" }}
              className="slide"
              style={{
                backgroundImage: `url(${currentSlide.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                // height:1500,
              }}
            >
              <div className="slide-overlay" />
              <motion.div
                className="slide-content"
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.8 }}
              >
                <h1 className="slide-title">{currentSlide.title}</h1>
                <p className="slide-subtitle">{currentSlide.subtitle}</p>
                <button
                  className="cta-button"
                  onClick={() => navigate("/contact")}
                >
                  Become A Client
                </button>
              </motion.div>
            </motion.div>
          </AnimatePresence>

          <div className="carousel-dots">
            {slides.map((_, i) => (
              <div
                key={i}
                className={`carousel-dot ${i === page ? "active" : ""}`}
              />
            ))}
          </div>
        </div>
      </motion.div>
      <section className="about-page">
        <motion.header
          className="about-hero"
          initial="hidden"
          animate="visible"
          variants={fadeUp}
        >
          <h1>About Us</h1>
          <p className="hero-subtitle">
            At TMC Contractors, we build more than structures—we build trust,
            relationships, and long-term value.
          </p>
        </motion.header>

        <div className="content-grid">
          <motion.div
            className="about-content"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
          >
            <h2>About TMC</h2>
            <p>
              Based in Indianapolis, Indiana, TMC is a full-service general
              contracting and project management firm specializing in public
              works, educational, commercial, and institutional construction
              projects across the state.
            </p>
            <p>
              Founded by <strong>Kevin Thomas</strong>, a construction industry
              veteran with over 30 years of experience, TMC was built on the
              principles of quality craftsmanship, operational integrity, and
              accountability. From small-scale renovations to complex
              infrastructure upgrades, our team brings excellence to every
              project.
            </p>
            <p>
              Our leadership team includes <strong>Gretchen Thomas</strong>,
              Vice President, who brings deep expertise in procurement,
              compliance, and organizational efficiency. Together, our executive
              and project teams offer seamless coordination, real-time project
              tracking, and hands-on field supervision using platforms like
              Contractor Foreman.
            </p>
          </motion.div>

          <motion.div
            className="image-container"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
            custom={1}
          >
            <figure>
              <img src="image/company_head.jpg" alt="TMC Building" />
              <figcaption>Our headquarters in Indianapolis</figcaption>
            </figure>
          </motion.div>
        </div>
        <motion.div
          className="about-highlight"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          custom={2}
        >
          <h2>What Sets Us Apart</h2>
          <ul>
            <li>
              Self-perform key trades like plumbing, carpentry, and
              demolition—for better control over quality, schedule, safety.
            </li>
            <li>
              Trusted partner to school districts, housing authorities,
              municipalities, and government agencies.
            </li>
            <li>
              Committed to flexibility, transparency, and responsiveness, always
              delivering on time and on budget.
            </li>
            <li>
              Certified as a Small Business and fully compliant with
              public‑sector contracting standards.
            </li>
          </ul>
        </motion.div>

        <motion.p
          className="about-footer"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          custom={3}
        >
          At TMC, every project is a partnership. We listen first, plan
          carefully, and execute with precision. Our goal is to exceed
          expectations, every time.
        </motion.p>
        <motion.div
          className="about-capability"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          custom={2}
        >
          {/* <h2
          style={{
            fontSize: "25",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%", // optional, ensures vertical centering if needed
            flexDirection: "column", // stack items vertically
            textAlign: "center", // centers text if there's any
          }}
        >
          Capabilities & Statments
        </h2> */}
          {/* <Capability /> */}
        </motion.div>
      </section>
    </>
  );
};

export default About;
